import { Team } from '../../../../../../pages/main/management/teams/types';
import { TeamManagement } from '../../../../../forms/AddTeamForm/types';

export type dataTable = Team;

export type TableProps = {
    data: Team[];
    onDeleteTeam?: (teamId: string) => void;
    onEditTeam?: (teamId: string, data: TeamManagement) => void;
};

export type SearchbarFilterTypes = (value: string) => void;

export const teamsColumnNames = {
    name: {
        id: 'name',
        label: 'Nom',
    },
    concessions: {
        id: 'concessions',
        label: 'Concessions',
    },
    roads: {
        id: 'roads',
        label: 'Carreteres',
    },
    users: {
        id: 'users',
        label: 'Operaris',
    },
    vehicles: {
        id: 'vehicles',
        label: 'Vehicles',
    },
};
